import type { SelectedFilter } from '../api/rest/types';
import { decompressSelectedFilterValues } from '../queryEncoding';

// Use selected filters derived from special SEO routes

export const useSeoFilters = (selectedFilters: SelectedFilter[]) => {
  const compressedValues = Object.fromEntries(
    selectedFilters
      .map(({ id, groupedValues }) => [
        id,
        groupedValues
          .flatMap((x) => x.values)
          .filter((x) => x.isSeoFilter)
          .map((x) => x.id),
      ])
      .filter((x) => x[1].length),
  );

  return {
    selectedSeoFilterValues: decompressSelectedFilterValues(compressedValues, selectedFilters),
  };
};
